import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../../hook";
import { useMemo } from "react";
import { approverType } from "../codeRequestType";
import { ITCodeRequestService } from "../../../../../services/it-code-request/itCodeRequest.service";

export const useDetailsPCR = () => {
  const { id } = useParams<{ id: string }>();
  const { checkCurrentUser } = useUser();

  const { data, isLoading } = useQuery({
    queryKey: ["code-process-requests", id],
    queryFn: () => ITCodeRequestService.getITCodeRequest(id),
    enabled: !!id,
  });

  const isPin = useMemo(() => {
    if (!data) return false;
    const pins: any[] = data.fields.ePins ? JSON.parse(data.fields.ePins) : [];
    return pins.findIndex((pin: string) => checkCurrentUser(pin)) >= 0;
  }, [checkCurrentUser, data]);

  const approvalType: number = useMemo(() => {
    if (!data) return 0;
    const {
      eApprovedBy,
      eApprovedByITLead,
      eApprovedByITHead,
      eAssignee,
      eApprovedStatus,
      eApprovedByITLeadStatus,
      eApprovedByITHeadStatus,
      eAssigneeStatus,
    } = data?.fields;
    const approverEmail = eApprovedBy ? eApprovedBy.split("|")[0] : "";
    const approvedByITLeadEmail = eApprovedByITLead ? eApprovedByITLead.split("|")[0] : "";
    const approvedByITHeadEmail = eApprovedByITHead ? eApprovedByITHead.split("|")[0] : "";
    const assigneeEmail = eAssignee ? eAssignee.split("|")[0] : "";

    if (checkCurrentUser(approverEmail) && !eApprovedStatus) return approverType.approver;
    if (checkCurrentUser(approvedByITLeadEmail) && !eApprovedByITLeadStatus) return approverType.itlead;
    if (checkCurrentUser(approvedByITHeadEmail) && !eApprovedByITHeadStatus) return approverType.ithead;
    if (checkCurrentUser(assigneeEmail) && !eAssigneeStatus) return approverType.assignee;
    return 0;
  }, [data, checkCurrentUser]);

  const approvalStep: number = useMemo(() => {
    if (!data) return approverType.approver;
    const { eApprovedStatus, eApprovedByITLeadStatus, eApprovedByITHeadStatus, eAssigneeStatus } = data?.fields;
    if (!eApprovedStatus) return approverType.approver;
    if (!eApprovedByITLeadStatus) return approverType.itlead;
    if (!eApprovedByITHeadStatus) return approverType.ithead;
    if (!eAssigneeStatus) return approverType.assignee;
    return approverType.approver;
  }, [data]);

  return { data, isLoading, isPin, approvalStep, approvalType };
};
